//LOADING
export const TOGGLE_LOADING = 'TOGGLE_LOADING'; 

// UNAUTHORIZE
export const UNAUTHORIZED_ACCOUNT = 'UNAUTHORIZED_ACCOUNT';

//ACCOUNT LIST
export const FETCH_ACCOUNT_LIST = 'FETCH_ACCOUNT_LIST';

// Account Details
export const USER_ACTIVITY_ACCOUNT_DETAILS = "USER_ACTIVITY_ACCOUNT_DETAILS";
// Account Details
export const STAR_DATA = "STAR_DATA";
